/*
 * Lookbook JS. 2013
*/



$(window).bind("resize load", function(){
    screenOrientation = ($(window).width() > $(window).height())? 90 : 0;

    if (screenOrientation == 90 ) {
    	$('body').addClass('landscape-mode');

	    screenHt = $(window).height();

	    if (screenHt < 800 ) {
	    	$('body').addClass('minht-mode');
	    } else {
	    	$('body').removeClass('minht-mode');
	    }

	    if (screenHt <= 900 ) {
	    	$('body.collection.slider').addClass('fluid-height-mode');
	    	$('body.collection.slider').removeClass('restricted-height-mode');
	    } else {
	    	$('body.collection.slider').addClass('restricted-height-mode');
	    	$('body.collection.slider').removeClass('fluid-height-mode');
	    }


    } else {
    	$('body').removeClass('landscape-mode');
    }


});

// -------------------------------------------------------------------------------------
// Fixed iOS iPad landscape mode bug with 100% height
// http://stackoverflow.com/questions/18855642/ios-7-css-html-height-100-692px
// -------------------------------------------------------------------------------------
if (navigator.userAgent.match(/iPad;.*CPU.*OS 7_\d/i)) {
	$('body').height(window.innerHeight);
	window.scrollTo(0, 0);
}

// -------------------------------------------------------------------------------------
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// -------------------------------------------------------------------------------------
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
	window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
	window.requestAnimationFrame = function(callback, element) {
	  var currTime = new Date().getTime();
	  var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	  var id = window.setTimeout(function() { callback(currTime + timeToCall); },
	   timeToCall);
	  lastTime = currTime + timeToCall;
	  return id;
	};
  }

  if (!window.cancelAnimationFrame) {
	window.cancelAnimationFrame = function(id) {
	  clearTimeout(id);
	};
  }
}());

// -------------------------------------------------------------------------------------
// Debounce function, taken from underscore.js
// -------------------------------------------------------------------------------------
function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}


// -------------------------------------------------------------------------------------
// Global Variables
// -------------------------------------------------------------------------------------
var w = getWidth(),
	h = getHeight(),
	desktopBreakPoint = 599,
	totalNavItemWidth = 0;

var siteNav = $('.site-nav'),
	navItems = $('.site-nav--item');

// -------------------------------------------------------------------------------------
// Functions
// -------------------------------------------------------------------------------------
function updateCoverImages() {
  if ( getWidth() < desktopBreakPoint ) {
	return;
  }

  $('.slide__image').each(function() {
	var el = $(this),
		iW = el.width();

	// if (el.parent().hasClass('gallery__slide')) {
	//   el.parent().css('width', iW);
	// } else {
	//   el.parent().parent().css('width', iW);
	// }
  });

};

function getWidth() {
  return window.innerWidth;
};

function getHeight() {
  return window.innerHeight;
};

function diff (a, b) {
  return Math.abs(a - b)
}

var fixNavWidth = debounce(function() {
  if ( getWidth() < desktopBreakPoint ) {
   return;
  }

  totalNavItemWidth = 0;

  navItems.each(function(e) {
	var el = $(this);
	totalNavItemWidth = totalNavItemWidth + parseInt(el.outerWidth());
  });

  // Toggle a class if the total items are (almost) wider than the container
  if ( totalNavItemWidth + 50 >= siteNav.outerWidth() ) {
	siteNav.addClass('site-nav--collapse');
  } else {
	siteNav.removeClass('site-nav--collapse');
  }

  siteNav.removeClass('is-processing').addClass('is-complete');

}, 250);


// -------------------------------------------------------------------------------------
// General theme JS
// -------------------------------------------------------------------------------------
$(function() {

  var navMenu = $('#navPrimary').hide();

  // Mobile menu toggle
  $('#toggleMobileNav').click(function(e){
	  e.preventDefault();
	  navMenu.slideToggle(350);
	  $(this).toggleClass('is-open');
  });

  // Force show/hide the menu based on screen width
  function navVisibility() {

	if ( getWidth() != w ) {
	  // The width changed, so update our global variable
	  w = getWidth();

	  // Toggle nav visibility based on width
	  if ( getWidth() > desktopBreakPoint ) {
		navMenu.show();
	  } else {
		navMenu.hide();
	  }
	} else {
	  // Width didn't change, but if we are on large screens show the nav
	  if ( getWidth() > desktopBreakPoint ) {
		navMenu.show();
	  }
	  return;
	}

  };

  // Toggle product info
  var toggleProductInfo = $('.toggle__productinfo');
  if (toggleProductInfo.length) {
	toggleProductInfo.hover(function() {
	 el = $(this);
	 tar = $('.product__info', el);

	 if ( w >= desktopBreakPoint ) {
	   tar.toggleClass('product__infoshow');
	 }
	});
  };

  // -------------------------------------------------------------------------------------
  // Functions run dependent on screen width. Must be updated on resizing.
  // -------------------------------------------------------------------------------------
  if ( $('html').hasClass('ie9') ) {
	// Update .slide__image parent on delay - hack for oldIE
	setTimeout(function() {
	  updateCoverImages();
	}, 400);

  } else {
	$(window).resize(function() {

	  // recheck site width for nav visibility
	  debounce( requestAnimationFrame(navVisibility), 250);

	  // Update cover image container on resize
	  debounce( requestAnimationFrame(updateCoverImages), 250);

	  siteNav.removeClass('is-complete').addClass('is-processing');
	  fixNavWidth();
	});
  }

  // Check what nav to show on load
  navVisibility();

  // Check if site-nav items fit in container on load
  fixNavWidth();

  // -------------------------------------------------------------------------------------
  // Wrap tables from the rich text editor so you can define a scrollable area
  // -------------------------------------------------------------------------------------
  $('.rte table').wrap('<div class="table-wrap"></div>');

});

// -------------------------------------------------------------------------------------
// Once everything loaded, check image sizes
// -------------------------------------------------------------------------------------
$(window).load(function() {
  updateCoverImages();

  // -------------------------------------------------------------------------------------
  // Gallery specific functions
  // -------------------------------------------------------------------------------------
  var gallery = $('.gallery-scroll');
  if (gallery.length) {

	// Steal the scroll event for the gallery only
	var movement = 0;
	gallery.on('mousewheel', function(event) {
	  if ( w >= desktopBreakPoint ) {
		event.preventDefault();
		if (event.deltaX > 0.5 || event.deltaX < -0.5) {
		  this.scrollLeft += (event.deltaX * event.deltaFactor);
		  arrowVisibility(this.scrollLeft);
		} else {
		  this.scrollLeft += (event.deltaY * event.deltaFactor);
		  arrowVisibility(this.scrollLeft);
		}
	  };
	});


	// Keyboard/arrow scrolling
	var currentScroll = 0,
		isScrolling = false;

	// Setup keyboard arrow scroll capability
	$(document).keydown(function(event){
	  switch (event.keyCode) {
		case 37: // left
		  event.preventDefault();
		  if (!isScrolling) {
			isScrolling = true;
			scrollGallery('left');
		  }
		  break;
		case 39: // right
		  event.preventDefault();
		  if (!isScrolling) {
			isScrolling = true;
			scrollGallery('right');
		  }
		  break;
	  }
	});

	// Setup hover scroll capability if enabled in theme settings
	
	  var leftArrow = '<div class="gallery-arrow gallery-left"></div>',
		  rightArrow = '<div class="gallery-arrow gallery-right"></div>',
		  autoInterval = null;

	  var numSlides = $('.gallery__slide').length;
	  var totalGalleryWidth = 0;
	  $('.gallery__slide').each(function(i) {
		totalGalleryWidth += $(this).width();
		if ((i + 1) == numSlides) {
		  if(totalGalleryWidth > $('.gallery__inner').width()) {
			gallery.append(leftArrow).append(rightArrow);
		  }
		}
	  });

	  var autoIncrement = 10,
		  intervalSpeed = 1;

	  var scrollLeftArrow = $('.gallery-arrow.gallery-left'),
		  scrollRightArrow = $('.gallery-arrow.gallery-right').show();

	  $('.gallery-arrow').mouseenter(function() {
		var el = $(this);
		if (el.hasClass('gallery-left')) {
		  autoScrollGallery('left');
		} else {
		  autoScrollGallery('right');
		}
	  }).mouseleave(function() {
		clearInterval(autoInterval);
	  });
	

	function autoScrollGallery(direction) {
	  if (isScrolling) return;
	  var scrollTracker = 0;

	  autoInterval = setInterval(function() {
		switch(direction) {
		  case 'right':
			var newLeft = gallery.scrollLeft() + autoIncrement;
			gallery.scrollLeft(newLeft);
			scrollTracker = gallery.scrollLeft();
			arrowVisibility(newLeft, scrollTracker);
			break;
		  case 'left':
			var newLeft = gallery.scrollLeft()-autoIncrement > 0 ? (gallery.scrollLeft()-autoIncrement) : 0;
			gallery.scrollLeft(newLeft);
			arrowVisibility(newLeft);
			break;
		}
	  }, intervalSpeed);
	}

	function scrollGallery(dir, speed, amount) {
	  dir = dir ? dir : 'right';
	  speed = speed ? speed : 200;
	  amount = amount ? amount : 650;

	  switch(dir) {
		case 'right':
		  gallery.animate({
			scrollLeft: gallery.scrollLeft()+amount
		  }, speed, function() {
			isScrolling = false;
		  });
		  break;
		case 'left':
		  gallery.animate({
			scrollLeft: gallery.scrollLeft()-amount > 0 ? (gallery.scrollLeft()-amount) : 0
		  }, speed, function() {
			isScrolling = false;
		  });
		  break;
	  }
	}

	function arrowVisibility(newLeft, oldLeft) {
	  if (newLeft == 0) {
		scrollLeftArrow.fadeOut(150);
	  }

	  else if ( newLeft > oldLeft ) {
		scrollRightArrow.fadeOut(150);
	  }

	  else {
	   scrollRightArrow.fadeIn(200);
	   scrollLeftArrow.fadeIn(200);
	  }

	}

  }
});



// -------------------------------------------------------------------------------------
// Custom functions
// -------------------------------------------------------------------------------------

// to detect if the browser used by the client is IE ( lte9 and 10 )
$(function(){
	$(window).load(function(){
		if( navigator.appName == "Microsoft Internet Explorer" ){
			$('html,body').addClass('ie');

			if (getWidth() >= 1200) {

				var footerHt = $('.site-footer').height();
				var winHeight = window.innerHeight - footerHt;

				var thumbHt = $('.thumbnail').height();
				var thumbImgHt = $('.thumbnail__image').height();
				var thumbPad = thumbHt-thumbImgHt;
				var heroHt = (thumbHt * 5)-thumbPad;
				var containerHt = (thumbHt * 5);

				$('.hero__slide').css({'height': heroHt+'px'});
				$('.category-hero').css({'height': containerHt+'px'});
				$('.template-collection,.collection.slider,.template-product').css({'overflow' : 'scroll'});
			};
		}
	});
});







// Preload Images
function preload(arrayOfImages) {
	$(arrayOfImages).each(function(){
		$('<img/>')[0].src = this;
	});
}
preload([
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/sprite-mood-toggles.png?v=13376588567136021051417726392',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/logo.png?v=151031275729041557621461950498',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/logo_white.png?v=51462834248954680071461950469',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_night_desktop.png?v=104535959153914443811417726387',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_night_tablet.png?v=76527519592641044941417726388',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_night_mobile.png?v=41425135861184369981417726388',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_day_desktop.png?v=5533588514297805881417726387',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_day_tablet.png?v=167764150856125217861417726387',
	'//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/imghero_day_mobile.png?v=167764150856125217861417726387'
]);






// Shows success message after newsletter addition.
// (temp solution)
$(function() {
	q = window.location.search.slice(1);
	if(q == "customer_posted=true"){
		$('.form__newsletter form').hide();
		$('.form__newsletter .success p').html("<strong>Thank You for Subscribing.</strong> You will receive the latest news and <span class='nightstyle trademark'>NightStyle<sup>TM</sup></span> updates from <span class='trademark miapiuma-text'>mia piuma<sup>TM</sup></span> nightwear.");
		$('.form__newsletter .success').fadeIn(500);
	}
});






// Trigger for Product Details
$(function() {

	$('.productpanel__description h3').html('<span class="condensed-title">Details</span>');

	$('.productpanel__description h3').on('click', function() {
		var moreDetailsTrigger = $(this);
		var moreDetailsConainer = moreDetailsTrigger.next('ul');
		var moreDetailsParentConainer = moreDetailsTrigger.parents('.productpanel__description');

		moreDetailsParentConainer.toggleClass('closed');
		moreDetailsTrigger.html('<span class="extended-title">Garment Details</span><span class="condensed-title" style="display: none;">Details</span>');
		moreDetailsConainer.slideToggle( function() {
			$('.product__social').fadeIn('800');
		});

	});

});





// Product Images Flexslider
$(function() {

	$(window).load(function() {

		// console.log('flex init');

		$('.template-product .flexslider').flexslider({
			animation: 'fade',
			selector: ".slides > .slide",
			slideshow: false,
			controlNav: false,
			controlsContainer: ".gallery__controls",
			prevText: "<span class='notranslate'>\u2329</span>",
			nextText: "<span class='notranslate'>\u232a</span>",
			touch: true,
			startAt: 0
		});


		$('#collection-slider').slick({
			appendArrows: '.gallery__controls ul',
			prevArrow: '<li><a class="flex-prev" href="#"><span class="notranslate">\u2329</span></a></li>',
			nextArrow: '<li><a class="flex-next" href="#"><span class="notranslate">\u232a</span></a></li>',
			mobileFirst: true,
			adaptiveHeight: true,
			speed: 400,
			responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 2,
				slidesToScroll: 2

		      }		      
		    },
		    {
		      breakpoint: 0,
		      settings: "unslick"		      
		    }

		  ]	
		});


	});

});



// $(document).ready(function(){

// 	$('#collection-slider').slick({
// 		appendArrows: $('.collection-slider__controls'),
		
// 		slidesToShow: 2,
// 		slidesToScroll: 2
// 		// responsivemobileFirst: true,
// 	});

// });


//setup color swatches
$(function(){
	// var color1 = 'midnight';
	// var color1name = '002548';
	// console.log(color1 + color1name);

	// $('.swatch--'+color1name ).css({'background-color':'#'+color1});
	// .swatch--#{$collection-color-01-name} label:before	{	border-color: 		$collection-color-01-hex !important;	}
});





// replace 'creme' with 'Cr&egrave;me'
$(function(){
	// $('.swatch--creme .opt-title').html('Cr&egrave;me');
});




// On hover show matching color option
$(function() {

if (Modernizr.touch == false) {
	// console.log('active slide set for non-touch');

	$('.single-option-selector.color li').hover(function() {

		var colorValue = $(this).find('input[type="radio"]').data('swatch-color');

		if (  !$('.flex-active-slide').hasClass('color-' + colorValue) ) {

			/* Check to see if there are any slides that match the color swatch */
			if ( $('.slide.color-' + colorValue).length ) {

				/* remove flex active from all slides */
				$('.slide').removeClass('flex-active-slide').css({ 'opacity':'0'});

				/* find flex.color hovered and make it active*/
				$('.slide.color-' + colorValue).addClass('flex-active-slide').css({ 'opacity': '1'});
			}

		}

	})
} else {
	// console.log('active slide set for touch');

		$('.single-option-selector.color li').change(function() {

		var colorValue = $(this).find('input[type="radio"]').data('swatch-color');
		// console.log(colorValue);

		if (  !$('.flex-active-slide').hasClass('color-' + colorValue) ) {

			/* Check to see if there are any slides that match the color swatch */

			if ( $('.slide.color-' + colorValue).length ) {
				// console.log('current slide is color value: ' + colorValue);

				/* remove flex active from all slides */
				$('.slide').removeClass('flex-active-slide').css({ 'opacity':'0'});

				/* find flex.color hovered and make it active*/
				$('.slide.color-' + colorValue).addClass('flex-active-slide').css({ 'opacity': '1'});
			}

		}

	})
}

});





// On select/checked show color name
$(function() {
	var swatchOpts = $('.single-option-selector.color input[type="radio"]');
	var swatchOptsFirst = swatchOpts.first().parent().addClass('is-checked');

	$('.single-option-selector.color input[type="radio"]').click(function(){

		var swatchOpt = $(this);

		swatchOpts.parent().removeClass('is-checked');

		if ( $(swatchOpt).is(':checked') ) {
			// console.log('checked+');
			$(this).parent().addClass('is-checked');
		};
	});

});





// Replace .PNG logos with .SVG

$(function(){
	if (Modernizr.svg) {
		$('.branding__logo').addClass('branding__logo--svg');
		$(".branding__logo:not(.branding__logo--white) img").attr("src", "//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/logo.svg?v=146406566288854150861461950511");
		$(".branding__logo.branding__logo--white img").attr("src", "//cdn.shopify.com/s/files/1/0714/8697/t/2/assets/logo_white.svg?v=58470103013638945501461950487");
	};
});






// Open external links in new window
$(function() {
	$('a').each(function() {
	   var a = new RegExp('/' + window.location.host + '/');
	   if(!a.test(this.href)) {
		   $(this).click(function(event) {
				event.preventDefault();
				event.stopPropagation();
				window.open(this.href);
				return false;
		   });
	   }
	});
});






currentW = getWidth();

if (currentW >= 1200 ) {
	$(window).load(function(){
		setGalleryMinHt();
		// setGalleryThumbHW();
		positionStickyFooter();
		fixedShoppingBag();
	});

	$(window).resize( function(){
		setGalleryMinHt();
		// setGalleryThumbHW();
		positionStickyFooter();
		fixedShoppingBag();
	});

} else  {
	$('.template-collection,.collection.slider,.template-product').css({'overflow' : 'scroll'});
};





function setGalleryMinHt() {
	if ( getHeight() <= 900 && getWidth() >= 1200 && !$('body').hasClass('colllection.slider') ) {
		$('colllection.slider .gallery.hasfooter,.template-collection .gallery.hasfooter,.template-product .gallery.hasfooter').css({'min-height' : '800px','overflow' : 'visible'});
		$('colllection.slider .gallery.hasfooter, .template-collection .gallery.hasfooter').css({'padding-bottom':0});
		// $('colllection.slider .gallery__inner, .template-collection .gallery__inner,.template-product .gallery__inner').css({	'min-height' : '800px'});
		$('colllection.slider,.template-collection,.template-product').css({'overflow' : 'scroll'});
		$('colllection.slider .shoppingbag,.template-collection .shoppingbag,.template-product .shoppingbag').css({'position' : 'fixed', 'overflow-y' : 'scroll'});
		$('colllection.slider .site-footer,.template-collection .site-footer,.template-product .site-footer').css({'position':	'initial'});
		// console.log('currentH under 900' );

		$('#shoppingBag').addClass('shoppingbagshowfixed').bind('load click', function(){
			getElementById('shoppingBag').setAttribute('style','position:fixed;');
		});

	} else {
		if ( !$('html').hasClass('ie') || !$('html').hasClass('ie9') ) {
			var bottomPadding = "94px";
			$('colllection.slider .gallery.hasfooter, .template-collection .gallery.hasfooter').css({'padding-bottom': bottomPadding });
			// $('.template-collection,.template-product').css({'overflow' : 'hidden'});
			$('colllection.slider .gallery,.template-collection .gallery,.template-product .gallery').css({'min-height' : 'none'});
			$('colllection.slider .site-footer,.template-collection .site-footer,.template-product .site-footer').css({'position':	'absolute'});
			$('colllection.slider .shoppingbag,.template-collection .shoppingbag,.template-product .shoppingbag').css({'position' : 'absolute'});
			// console.log('currentH NOT under 900');
		}
	};
}





// Sets Gallery Thumbnails equal to their height
function setGalleryThumbHW() {
	var thumbImgs = $('.template-collection .thumbnail__image, .collection.slider .thumbnail__image');
	var thumbImgH = thumbImgs.first().height();
	thumbImgs.css({'width' : thumbImgH });
	// console.log('thumb height ' + thumb ImgH, 'height' : 'auto' );
}





// Make shopping bag continue to be fixed even after it has been opened and closed (initial styles removed on close and replaced with class)
function fixedShoppingBag() {
	$('#shoppingBag').addClass('shoppingbagshowfixed').bind('load click', function(){
		getElementById('shoppingBag').setAttribute('style','position:fixed;');
	});
}





// Position the footer correctly based on window height
function positionStickyFooter() {
	var isStickyFooter = false;
	currentW = getWidth();
	currentH = getHeight();

	var windowHt = $(window).height();
	var documentHt = $(document).height();

	if ( currentH <= 1100 ) {
		// console.log('11 currentH ' + currentH + ' currentW ' + currentW);
		$('.template-generic .site-footer').animate({ 'margin-top': '0px' }, 'fast' );
	} else {
		// console.log('currentH ' + currentH + ' currentW ' + currentW);
		var siteFooterHt = '94px';
		var siteFooterHtIgr = siteFooterHt.split('px', 1);
		var siteFooterTopMargin = -1*(siteFooterHtIgr*2);
		// $('.template-generic .site-footer').animate({ 'margin-top': siteFooterTopMargin +'px' }, 'fast' );
	}

	var pageSectionHt = $('.template-generic section.page').height();
	var leftSectionHt = $('.template-generic .section-left-content').height();
	var rightSectionHt = $('.template-generic .section-right-content').height();
	// console.log('leftSectionHt ' + leftSectionHt + ' rightSectionHt ' + rightSectionHt);
	// console.log('windowHt ' + windowHt + ' documentHt ' + documentHt + ' pageSectionHt ' + pageSectionHt);

	if (leftSectionHt <= rightSectionHt && rightSectionHt == currentH) {
		isStickyFooter = true;
		// console.log('sticky');

		var headerHt = $('.site-nav').height();
		var footerTopPadding = $('.site-footer').css('padding-top').split('px', 1);
		var footerHt = $('.site-footer').height();
		var footerTotalHt = parseInt(footerHt) + parseInt(footerTopPadding);
		// var footerHt = $('.site-footer').height() + $('.site-footer').css('padding-top');

		var newRightSectionHt = parseInt(rightSectionHt) - parseInt(headerHt) - parseInt(footerTotalHt);
		$('.template-generic .section-right-content').css({'height': newRightSectionHt + 'px'});
		$('#mainContainer').css({'margin-bottom': footerTotalHt*-1 + 'px'});

	} else {
		isStickyFooter = false;
		// console.log('!not sticky');
	}


}





// Size chart toggle
$(function() {
	$('.sizechart__toggle').click( function (e) {
		$('.sizechart__overlay').fadeToggle();
		e.preventDefault();
	});
});



// Add class to first image in blog content
$(function() {

	$('.article.large-collage .blog__content img').first().addClass('blog__content-hero');
	$('.article.large-collage .blog__content img.blog__content-hero').parent('p').addClass('blog__content-hero-paragraph');

});




// language-toggle
$(function() {
	$('.language-toggle').click( function (e) {
		e.preventDefault();
		$( this ).fadeOut( 100 );
		$('.language-dropdown').delay(100).fadeToggle();
	});
});



// Add span to night style to avoid google translate from changing
$(function() {
	$('.nightstyle').wrapInner('<span class="notranslate"></span>');
});